import { Divider } from '@ksyos/design-system';
import type { IOrthOV1ProcedureExaminationsProps } from './OrthOV1ProcedureExaminations';
import { CircleCountHeading } from '../../../elements/CircleCountHeading';
import { OrthOExaminationOrder } from './orthOExaminationOrder';
import { OrthOV1ProcedureSelectedExtraBinocularExaminations } from './OrthOV1ProcedureSelectedExtraBinocularExaminations';
import { ReadOrEditInputField } from './ReadOrEditInputField';

export function OrthOV1ProcedureBinocularFunctions(props: IOrthOV1ProcedureExaminationsProps) {
    return (
        <>
            <CircleCountHeading
                count="2"
                label="Binoculaire functies"
            />
            <ReadOrEditInputField
                {...props}
                error={props.errors?.get('customControlData.stereotest')}
                fieldKey="stereotest"
                hasErrors={props.errors?.has('customControlData.stereotest')}
                isRequired={true}
                label="orthOProcedure.stereotest"
                placeholder="Bevindingen..."
                tabIndex={OrthOExaminationOrder.binocularExamination}
                value={props.customControlData.stereotest}
            />

            <OrthOV1ProcedureSelectedExtraBinocularExaminations {...props} />
            <Divider
                color="minimal"
                spacing="medium"
            />
        </>
    );
}
